import { X } from "lucide-react";

type Props = {
  open: boolean;
  onClose: () => void;
};

export function LaunchNoticeModal({ open, onClose }: Props) {
  if (!open) return null;

  return (
    <div className="modal-backdrop" role="presentation">
      <div className="auth-modal launch-notice-modal" role="dialog" aria-modal="true" aria-labelledby="launch-notice-title">
        <button className="icon-button modal-close" type="button" onClick={onClose} aria-label="关闭">
          <X size={18} />
        </button>
        <div className="auth-heading launch-notice-heading">
          <div className="eyebrow">Coming Soon</div>
          <h2 id="launch-notice-title">产品即将上线，尽请期待！</h2>
          <p>相关内容正精细打磨完善，全新成果将于近期正式面世，诸多亮点，敬请关注官方后续发布</p>
        </div>
        <button className="button button-primary launch-notice-action" type="button" onClick={onClose}>
          我知道了
        </button>
      </div>
    </div>
  );
}
